import * as types from './mutation-types'

export default {
  [types.SET_WORKSTATION_LIST] (state, stationlist) {
    state.workStationList = stationlist
    state.workStationMap = {}
    stationlist.map(o => {
      state.workStationMap[o.id] = true
    })
    state.currentStation = state.workStationMap[state.currentStation] ? state.currentStation : ''
  },
  [types.TOGGLE_WORKSTATION] (state, stationId) {
    state.currentStation = stationId
  },
  [types.TOGGLE_IS_MAIN_CHANNEL] (state) {
    const isWorkMainChannel = !state.isWorkMainChannel
    state.isWorkMainChannel = isWorkMainChannel
  }
}
